import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormControlService {
  constructor() {}

  create(value: any, required = false, validators: ValidatorFn[] = []) {
    const validatorList = [...validators];
    if (required) {
      validatorList.push(Validators.required);
    }
    return new FormControl(value, validatorList);
  }

  addToFormGroup(formGroup: FormGroup, name: string, value: any, required = false, validators: ValidatorFn[] = []) {
    formGroup.addControl(name, this.create(value, required, validators));
  }
}
